/* --------------------------------------------------
Import moduels
-------------------------------------------------- */

import CanvasParallaxController from 'canvas-parallax';

/* --------------------------------------------------
Document Setup
-------------------------------------------------- */

class ParallaxImageElement extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({
      mode: 'open'
    });

    // Get the attributes
    this.depth = parseInt(this.getAttribute('depth'));
    this.focus = this.getAttribute('focus') || '50% 50%';
    this.alt = this.getAttribute('alt') || '';
    this.source = null;
    this.sources = {
      portrait: this.getAttribute('portrait'),
      landscape: this.getAttribute('landscape')
    };
    if (this.depth === undefined) this.depth = 0;

    // Add a style element to the shadow root
    const styleTag = document.createElement('style');

    // Set up an object for the styles
    let styles = `
      canvas {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }`;

    // Add the styles to the style tag
    styleTag.textContent = styles;

    // Append the style to the shadow root
    this.shadowRoot.appendChild(styleTag);
  }
  src() {
    const orientation = window.innerWidth <= window.innerHeight ? 'portrait' : 'landscape';
    // Get the sizes array based on the orientation
    const sources = this.sources[orientation];
    // Split the sizes string into an array
    const sizes = sources.split(', ');
    // Set the src based on the viewport width
    let src = '';

    // Loop through the sizes array
    sizes.forEach(data => {
      // Split the size string into an array
      const [source, size] = data.split(' ');

      // If the size is undefined then it is the default image to load
      if (size === undefined) return src = source;

      // If the viewport height is larger than the height of the image, set the src to the image
      if (orientation === 'portrait') {
        if (this.clientWidth >= parseInt(size)) src = source;
      }

      // If the viewport width is larger than the width of the image, set the src to the image
      if (orientation === 'landscape') {
        if (this.clientWidth >= parseInt(size)) src = source;
      }
    });
    return src;
  }
  render() {
    // Make sure we have all the information needed to render the image
    if (!this.focus) return;
    if (this.depth == undefined || isNaN(this.depth)) return;
    if (!this.sources || !this.sources.portrait || !this.sources.landscape) return;

    // Grab the source
    const src = this.src();

    // Make sure the source is not the same as the current source
    if (this.source === src) return;

    // Set the source to the new source
    this.source = src;
    const depth = window.innerWidth <= window.innerHeight ? this.depth * .5 : this.depth;

    // Remove the canvas if it exists
    if (this.canvas && this.shadowRoot.contains(this.canvas)) {
      this.shadowRoot.removeChild(this.canvas);
    }

    // Create a new CanvasParallaxController instance
    this.controller = new CanvasParallaxController({
      depth
    });

    // Grab the canvas element from the controller
    this.canvas = this.controller.canvas.element;

    // Append the div to the shadow root
    this.shadowRoot.appendChild(this.canvas);
    // Set the alt attribute of the canvas element
    this.canvas.setAttribute('aria-label', this.alt);

    // Load the image
    this.controller.load(this.source, this.focus);
  }

  // get the attributes
  static get observedAttributes() {
    return ['depth', 'alt', 'portrait', 'landscape', 'focus'];
  }

  // When the attributes change
  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'portrait') {
      this.sources.portrait = newValue;
      this.render();
    }
    if (name === 'landscape') {
      this.sources.landscape = newValue;
      this.render();
    }
    if (name === 'depth') {
      this.depth = parseInt(newValue);
      this.render();
    }
    if (name === 'focus') {
      this.focus = newValue;
      this.render();
    }
    if (name === 'alt') {
      this.alt = newValue;
      this.render();
    }
  }
  connectedCallback() {
    this.render();
  }
}
customElements.define('img-parallax', ParallaxImageElement);